import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { OrderWizardDataV26Service } from 'src/app/services-v26/wizards/order-wizard-data-v26.service';
import * as ReactivateAssetWizardActionsV26 from './actions';

@Injectable()
export class ReactivateAssetWizardEffectsV26 {
  assetServiceInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReactivateAssetWizardActionsV26.selectInitStep),
      concatMap(({ initStep }) =>
        this.productWizardService.getAssetSubscriptionsByAssetId(initStep.assetId, true).pipe(
          map((response) => {
            if (response) {
              return ReactivateAssetWizardActionsV26.selectAssetServicesInit({
                initAssetServiceStep: response.data ? response.data : [],
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(ReactivateAssetWizardActionsV26.exitReactivateAssetWizard());
          }),
        ),
      ),
    ),
  );

  newOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReactivateAssetWizardActionsV26.createNewReactivateAsset),
      concatMap(({ newOrder }) =>
        this.productWizardService.reactivateProductServices(newOrder).pipe(
          map((response) => {
            if (response) {
              return ReactivateAssetWizardActionsV26.createNewOrderSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(ReactivateAssetWizardActionsV26.createNewOrderFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private productWizardService: OrderWizardDataV26Service,
  ) {}
}
